import React, { useState, useEffect } from 'react';
import Navbar from '../../components/navbar';
import Footer from '../../components/Footer';
import './ICAIMPage.css';

const stats = [
  { value: '121+', label: 'Research Papers', detail: 'High-quality papers from scholars & academicians', icon: 'document' },
  { value: '200+', label: 'Delegates', detail: 'Intellectuals from Agriculture, Healthcare and IT', icon: 'user' },
  { value: '3+', label: 'Global Partners', detail: 'AMC, AFG, and MACCIA', icon: 'globe' },
  { value: 'Blended', label: 'Conference Mode', detail: 'In-person with international Skype sessions', icon: 'group' },
  { value: 'Sustainability', label: 'Vision Focus', detail: 'Leveraging IT in Agriculture & Medicine', icon: 'eye' },
];

const heroHighlights = ['Sustainable Agriculture', 'Sustainable Healthcare', 'AI & Deep Learning', 'IoT & Data Science', 'Optimizing Healthcare (SEO)'];

const themes = [
  {
    title: 'Agriculture',
    description: 'Artificial Intelligence for Extension Management, Satellite Imaging, Hydroponics, and Sustainable Irrigation.',
    tone: 'green',
  },
  {
    title: 'Healthcare (Medicine)',
    description: 'Multichannel Marketing in Healthcare, Sustainable Healthcare as an engine for the future, and SEO for Doctors.',
    tone: 'blue',
  },
  {
    title: 'Information Technology',
    description: 'Blockchain in Agriculture, IoT, AWS, R Programming, and Cyber Security for Sustainability.',
    tone: 'violet',
  },
];

const preConferenceSchedule = [
  { date: '03-02-2020', time: 'Session', topic: 'Hydroponics – Sustainable Agriculture', speaker: 'Mr. Vijay Yelmalle, CRAFT' },
  { date: '04-02-2020', time: 'Session', topic: 'Block Chain in Agriculture', speaker: 'Mr. Pankaj Mittal, Digital Enabler, Aurigraph.io' },
  { date: '04-02-2020', time: 'Session', topic: 'Use of IT for Healthcare – Solutions by TCS', speaker: 'Mr. Sujith Shinde, TCS Innovation Labs Mumbai' },
  { date: '05-02-2020', time: 'Session', topic: 'Cyber Security for Sustainability', speaker: 'Mr. Gaurav Batra, Founder, Cyberfrat' },
  { date: '3, 4 & 7 Feb 2020', time: 'Workshop', topic: 'IoT Workshop (Arduino, Raspberry Pi, AWS)', speaker: 'TIMSCDR IoT Team' },
  { date: '05 & 06 Feb 2020', time: 'Workshop', topic: 'Data Science with R Programming', speaker: 'TIMSCDR Faculty' }
];

const panelMembers = [
  'Mr. Vijay Yelmalle, Proprietor, CRAFT',
  'Mr. Vishal Sanghavi, CEO, Net2Point',
  'Mr. Dineshkumar Singh, Group Leader, mKRISHI®',
  'Dr. Joy Chakraborty, COO, Hinduja Hospital',
  'Mr. Nitiraj Gandhi, Jt. Secretary, HIMSS APAC India Chapter',
  'Mr. Sanjay Kimbahune, Senior Consultant, TCS Innovation Labs'
];

const paperAwards = [
  { category: 'Faculty - 1st Prize', title: 'Smart Air Fertigation (SAF) without using Fertilizers through Air Irrigation for Sustainable Agriculture', authors: 'Dr. Vinita Gaikwad, Mr. Manohar Khake, Mr. Pankaj Mudholkar' },
  { category: 'Student - 1st Prize', title: 'A Solar Light Trap for Control of Field Crop from Insects', authors: 'Ms. Sakshi Kori' },
  { category: 'Student - 2nd Prize', title: 'A Study of A.I. and Robotics Impact and their contribution in HealthCare Sector', authors: 'Mr. Devnath Jayaswal' }
];

const partners = ['AMC', 'AFG', 'MACCIA'];
const galleryCards = ['Inauguration Ceremony', 'Keynote Speakers', 'Panel Discussion', 'Doctor\'s Workshop', 'Paper Presentations'];
const carouselImages = [
  'https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1551818255-e6e10975bc17?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&w=800&q=80'
];

const icon = (kind) => {
  const common = { fill: 'none', stroke: 'currentColor', strokeWidth: '1.9', strokeLinecap: 'round', strokeLinejoin: 'round' };
  if (kind === 'calendar') return <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2" {...common} /><path d="M8 3v4M16 3v4M3 10h18" {...common} /></svg>;
  if (kind === 'location') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s6-5.4 6-11a6 6 0 1 0-12 0c0 5.6 6 11 6 11Z" {...common} /><circle cx="12" cy="10" r="2.5" {...common} /></svg>;
  if (kind === 'document') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 3h7l4 4v14H7V3Z" {...common} /><path d="M14 3v5h5M10 13h6M10 17h6M10 9h2" {...common} /></svg>;
  if (kind === 'user') return <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4" {...common} /><path d="M5 21c1.2-4 4-6 7-6s5.8 2 7 6" {...common} /></svg>;
  if (kind === 'globe') return <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" {...common} /><path d="M3 12h18M12 3c2.2 2.4 3.3 5.4 3.3 9S14.2 18.6 12 21M12 3c-2.2 2.4-3.3 5.4-3.3 9S9.8 18.6 12 21" {...common} /></svg>;
  if (kind === 'group') return <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="9" r="3.2" {...common} /><circle cx="17" cy="10" r="2.6" {...common} /><path d="M3.5 21c.9-3.9 3-6 5.5-6s4.6 2.1 5.5 6M14.5 16c2.4.2 4.2 1.9 5 5" {...common} /></svg>;
  if (kind === 'eye') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 12s3.6-6 9.5-6 9.5 6 9.5 6-3.6 6-9.5 6-9.5-6-9.5-6Z" {...common} /><circle cx="12" cy="12" r="3" {...common} /></svg>;
  if (kind === 'arrow') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" {...common} /></svg>;
  if (kind === 'leaf') return <svg width="36" height="36" stroke="#ffffff" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 14c0-5.5 4.5-10 10-10h4v4c0 5.5-4.5 10-10 10H5v-4Z" {...common} /><path d="M8 16c3-5 6-7 11-10" {...common} /></svg>;
  if (kind === 'medical') return <svg width="36" height="36" stroke="#ffffff" viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="3" width="14" height="18" rx="2" {...common} /><path d="M12 8v8M8 12h8" {...common} /></svg>;
  if (kind === 'chip') return <svg width="36" height="36" stroke="#ffffff" viewBox="0 0 24 24" aria-hidden="true"><rect x="7" y="7" width="10" height="10" rx="2" {...common} /><path d="M9 1v4M15 1v4M9 19v4M15 19v4M1 9h4M1 15h4M19 9h4M19 15h4" {...common} /></svg>;
  if (kind === 'download') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" {...common} /></svg>;
  return null;
};

const Icaim20 = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % carouselImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);

  const handleScrollToSection = (event, sectionId) => {
    event.preventDefault();
    const target = document.getElementById(sectionId);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="icaim25Page icaim24Page">
      <Navbar />
      <main className="icaim25Main">
        <section className="icaim25Hero">
          <div className="icaim25HeroShell glass-panel-dark">
            <div className="icaim25HeroGrid" id="icaim25-content">
              <div className="icaim25HeroCopy">
                <span className="icaim25HeroKicker">ICAIM 2020</span>
                <h1 className="icaim25HeroLead">
                  IT for Sustainability in Agriculture & Medicine
                </h1>
                <p className="icaim25HeroSubtitle">
                  Theme: "Leveraging Information Technology for Sustainability in Agriculture and Medicine"
                </p>

                <div className="icaim25HeroHighlights" aria-label="Conference focus areas">
                  {heroHighlights.map((highlight) => (
                    <span key={highlight}>{highlight}</span>
                  ))}
                </div>

                <div className="icaim25HeroMetaInline">
                  <div className="icaim25MetaItemInline">
                    <span className="icaim25MetaIconInline">{icon('calendar')}</span>
                    <span>8 - 9 February 2020</span>
                  </div>

                  <span className="icaim25MetaSeparator">|</span>

                  <div className="icaim25MetaItemInline">
                    <span className="icaim25MetaIconInline">{icon('location')}</span>
                    <span>TIMSCDR, Mumbai</span>
                  </div>
                </div>

                <div className="icaim25HeroActions">
                  <a
                    href="#overview"
                    className="icaim25PrimaryButton text-center"
                    style={{ textDecoration: 'none' }}
                    onClick={(event) => handleScrollToSection(event, 'overview')}
                  >
                    <span>Explore Conference</span>
                    <span className="icaim25ButtonIcon">{icon('arrow')}</span>
                  </a>
                  <a
                    href="#publications"
                    className="icaim25SecondaryButton text-center"
                    style={{ textDecoration: 'none' }}
                    onClick={(event) => handleScrollToSection(event, 'publications')}
                  >
                    <span>View Publications</span>
                    <span className="icaim25ButtonIcon">{icon('document')}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="icaim25StatsSection" id="about">
          <div className="icaim25StatsGrid glass-panel-light">
            {stats.map((stat, index) => (
              <div className="icaim25StatCard" key={stat.label}>
                <div className={`icaim25StatIcon statTone${index + 1}`}>{icon(stat.icon)}</div>
                <div>
                  <div className="icaim25StatValue">{stat.value}</div>
                  <div className="icaim25StatLabel">{stat.label}</div>
                  <div className="icaim25StatDetail">{stat.detail}</div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="icaim25AboutSection" id="overview">
          <div className="icaim25AboutGrid">
            <div className="icaim25SectionIntro">
              <span className="icaim25SectionTag">Conference Overview</span>
              <h2>Pioneering Sustainability through IT.</h2>
              <p>
                Thakur Institute of Management Studies, Career Development and Research (TIMSCDR) organized <strong>ICAIM 2020</strong> on 8-9 February 2020. This unique interdisciplinary conference brought stakeholders from Agriculture, Healthcare, and IT onto a common platform to deliberate and discuss futuristic technological enhancements.
              </p>
              <p>
                Arranged in association with AMC, AFG, and MACCIA, the event witnessed participation from over 200 delegates and intellectuals aiming to exchange ideas on leveraging IT for sustainability.
              </p>
            </div>

            <div className="icaim25StageCard glass-panel-light" aria-hidden="true">
              <div className="icaim25StageHeader">ICAIM 2020</div>
              <div className="icaim25StageScreen">
                <div className="icaim25CarouselTrack">
                  {carouselImages.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt={`Conference slide ${index + 1}`}
                      className={`icaim25CarouselImg ${index === currentSlide ? 'active' : ''}`}
                    />
                  ))}
                  <div className="icaim25CarouselOverlay"></div>
                </div>
                <div className="icaim25StageAudience" />
              </div>
            </div>
          </div>
        </section>

        <section className="icaim25ThemeSection">
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Theme Focus</span>
          </div>
          <div className="icaim25ThemeGrid">
            {themes.map((theme, index) => (
              <article className={`icaim25ThemeCard tone-${theme.tone}`} key={theme.title}>
                <div className="icaim25ThemeCardIcon">
                  {icon(index === 0 ? 'leaf' : index === 1 ? 'medical' : 'chip')}
                </div>
                <h3>{theme.title}</h3>
                <p>{theme.description}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="icaim25NarrativeSection" id="events">
          <div className="icaim25CenteredHeading" style={{ marginTop: '50px' }}>
            <span className="icaim25SectionTag">Event Highlights</span>
          </div>
          <div className="icaim25NarrativeGrid">
            <article className="icaim25NarrativeCard glass-panel-light">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag" style={{ color: 'var(--icaim-accent)' }}>Day 1 - 8 February 2020</span>
                <h3 style={{ marginTop: '8px', fontSize: '1.6rem', color: 'var(--icaim-text)' }}>Inauguration & Agriculture Focus</h3>
              </div>
              <p>
                Inaugurated by Chief Guest <strong>Dr. U. V. Mahadkar</strong> (Associate Dean, Dr. Balasaheb Sawant Konkan Krishi Vidyapeeth) alongside Mr. Santosh Mandlecha, Mr. Akshay Shah, and Dr. Vinita Gaikwad. The Conference Proceedings featuring 121 research papers were unveiled.
              </p>
              <p>
                The programme featured global insights with speakers like <strong>Dr. Srikanth Rupavatharam</strong> (Germany) on AI for Extension Management, <strong>Mr. Jae Sabol</strong> (USA) on Sustainability at One Community, and <strong>Mr. Marco Brini</strong> (Switzerland) on Technology for Sustainable Agriculture. The day included robust panel discussions on the role of IT in sustainable agriculture.
              </p>
            </article>

            <article className="icaim25NarrativeCard glass-panel-light">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag" style={{ color: 'var(--icaim-accent)' }}>Day 2 - 9 February 2020</span>
                <h3 style={{ marginTop: '8px', fontSize: '1.6rem', color: 'var(--icaim-text)' }}>Healthcare & SEO Optimization</h3>
              </div>
              <p>
                Inaugurated by Chief Guest <strong>Dr. Mukesh Gupta</strong> (President, AMC), followed by the unveiling of the workshop book <em>"Optimizing Healthcare – SEO"</em>. Erudite speakers including <strong>Dr. Indira Mallo</strong>, <strong>Pooja Krishnani Shah</strong>, and <strong>Dr. Joy Chakraborty</strong> shared insights on sustainable healthcare and multichannel marketing.
              </p>
              <p>
                The day featured a specialized Doctor's Workshop to help medical professionals optimize their online presence, build websites, and understand web analytics, ensuring technology-driven sustainability in medical practice.
              </p>
            </article>
          </div>
        </section>

        <section className="icaim25FeatureSection" id="speakers">
          <div className="icaim25FeatureGrid">
            <article className="icaim25DarkPanel glass-panel-dark">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag">Workshops &amp; Special Events</span>
                <h2>Applied learning and skill development.</h2>
              </div>
              <div className="icaim25WorkshopGrid">
                <div className="icaim25WorkshopCard highlight-green">
                  <h3>Doctor&apos;s Workshop</h3>
                  <p>Optimizing Healthcare – SEO. Equipping doctors with tools to enhance their digital footprint.</p>
                  <ul>
                    <li>Website Creation</li>
                    <li>Search Engine Optimization (SEO)</li>
                    <li>Keyword Strategy</li>
                    <li>Web Analytics Tools</li>
                  </ul>
                </div>
                <div className="icaim25WorkshopCard highlight-orange">
                  <h3>Technical Student Workshops</h3>
                  <p>Hands-on sessions spanning fundamental hardware setup to advanced data mining.</p>
                  <div className="icaim25JudgesBlock">
                    <strong>Highlights</strong>
                    <span>IoT Workshop: Arduino, Raspberry Pi, Python & AWS (3,4,7 Feb)</span>
                    <span>Data Science Workshop: R Programming & Statistical Computing (5,6 Feb)</span>
                  </div>
                </div>
              </div>
            </article>

            <article className="icaim25NarrativeCard glass-panel-light" id="pre-conference">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag" style={{ color: 'var(--icaim-primary)' }}>Pre-Conference</span>
                <h3 style={{ marginTop: '8px', fontSize: '1.6rem', color: 'var(--icaim-text)' }}>Expert Sessions</h3>
              </div>
              <p style={{ marginBottom: '16px' }}>
                Conducted from 3-7 February 2020, focusing on hydroponics, blockchain, and robust cybersecurity.
              </p>
              <div className="icaim25TableWrap glass-table">
                <table className="icaim25Table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Topics</th>
                      <th>Speaker Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {preConferenceSchedule.map((session, i) => (
                      <tr key={i}>
                        <td><strong>{session.date}</strong><br /><span style={{ fontSize: '0.85em', color: 'var(--icaim-text-muted)' }}>{session.time}</span></td>
                        <td>{session.topic}</td>
                        <td>{session.speaker}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>
          </div>
        </section>

        <section className="icaim25ResearchSection" id="awards">
          <div className="icaim25CenteredHeading" style={{ marginTop: '80px' }}>
            <span className="icaim25SectionTag">Proceedings & Recognitions</span>
            <h2 style={{ fontSize: '2.2rem', marginTop: '10px' }}>121 Research Papers</h2>
            <p style={{ color: 'var(--icaim-text-muted)', maxWidth: '700px', margin: '10px auto' }}>
              Selected after a rigorous review process and presented before distinguished professionals from Agriculture, Healthcare, and IT sectors.
            </p>
          </div>

          <div className="icaim25SessionChairs" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center', marginBottom: '40px' }}>
            {panelMembers.map((chair, i) => (
              <span key={i} className="icaim25Badge">{chair}</span>
            ))}
          </div>

          <div className="icaim25AwardsStack">
            <article className="icaim25NarrativeCard glass-panel-light">
              <h3 style={{ color: 'var(--icaim-primary)', marginBottom: '16px' }}>Research Paper Awards</h3>
              <div className="icaim25TableWrap glass-table">
                <table className="icaim25Table">
                  <thead>
                    <tr>
                      <th>Award Category</th>
                      <th>Research Paper Title</th>
                      <th>Authors</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paperAwards.map((award, i) => (
                      <tr key={i}>
                        <td><strong style={{ color: award.category.includes('1st Prize') ? 'var(--icaim-accent)' : 'inherit' }}>{award.category}</strong></td>
                        <td>{award.title}</td>
                        <td>{award.authors}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>
          </div>
        </section>

        <section className="icaim25PublicationsSection" id="publications" style={{ padding: '60px 20px', background: 'var(--icaim-bg-alt)' }}>
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Publications</span>
            <h2 style={{ fontSize: '2rem', marginTop: '10px' }}>Optimizing Healthcare & ICAIM 2020 Journal</h2>
            <p style={{ color: 'var(--icaim-text-muted)', maxWidth: '600px', margin: '15px auto 30px' }}>
              Access the "Optimizing Healthcare – SEO" workshop book and the official published journal featuring interdisciplinary research papers.
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <a 
                href="/path/to/Optimizing-Healthcare-Book.pdf" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="icaim25PrimaryButton" 
                style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}
              >
                <span className="icaim25ButtonIcon" style={{ margin: 0 }}>{icon('download')}</span>
                <span>Download "Optimizing Healthcare" Book</span>
              </a>
              <a 
                href="/path/to/ICAIM-2020-Journal-Publication.pdf" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="icaim25SecondaryButton" 
                style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}
              >
                <span className="icaim25ButtonIcon" style={{ margin: 0 }}>{icon('document')}</span>
                <span>Download ICAIM 2020 Journal</span>
              </a>
            </div>
          </div>
        </section>

        <section className="icaim25PartnersSection">
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Our Partners &amp; Associations</span>
          </div>
          <div className="icaim25PartnersGrid">
            {partners.map((partner) => (
              <div className="icaim25PartnerCard glass-panel-light" key={partner}>
                <div className="icaim25PartnerMark">{partner.charAt(0)}</div>
                <div className="icaim25PartnerName">{partner}</div>
              </div>
            ))}
          </div>
        </section>

        <section className="icaim25GallerySection" id="gallery">
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Glimpses From ICAIM 2020</span>
          </div>
          <div className="icaim25GalleryGrid">
            {galleryCards.map((card, index) => (
              <div className={`icaim25GalleryCard gallery-${index + 1}`} key={card}>
                <span>{card}</span>
              </div>
            ))}
          </div>
        </section>

      </main>

      <Footer />
    </div>
  );
};

export default Icaim20;